<template>
  <a-layout>
    <a-layout-content :style="{background: '#fff', padding: '24px', margin: 0, minHeight: '280px'}">
      <div class="about">
        <h2>我是无解</h2>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<style>
.about {
  line-height: 30px;
  padding: 40px;
  background-color: #f5f5f5;
  font-size: 16px;
}
.about h2 {
  margin-bottom: 30px;
  font-weight: 700;
}
.about img {
  margin-top: 10px;
}
</style>